export default __webpack_public_path__ + "static/media/videoPlayer.0379d5d1.svg";